import extrairMensagemErro from "./extrairMensagemErro";

// getFile usa responseType "arraybuffer", então no erro error.response.data também vem como
// ArrayBuffer (não JSON já parseado) - extrairMensagemErro não enxerga .detail/.message nesse
// formato, precisa decodificar o texto primeiro.
export default function extrairMensagemErroArquivo(error, mensagemPadrao) {
  try {
    const dados = error?.response?.data;
    if (dados instanceof ArrayBuffer) {
      const json = JSON.parse(new TextDecoder("utf-8").decode(dados));
      const mensagemDetalhe = Array.isArray(json?.detail) ? json.detail[0]?.message_error : null;
      return mensagemDetalhe || json?.message || mensagemPadrao;
    }
  } catch {
    // corpo de erro não veio como JSON válido - usa mensagem padrão
  }
  return extrairMensagemErro(error, mensagemPadrao);
}
